import type { FC } from 'react';

import type { LocationFilterDTO } from '@cognite/apm-config';
import { Breadcrumbs } from '@cognite/cogs-core-v11/components/breadcrumbs/breadcrumbs.tsx';
import { ListIcon } from '@cognite/cogs-icons-v11/system-icons/ListIcon.tsx';
import { LocationIcon } from '@cognite/cogs-icons-v11/system-icons/LocationIcon.tsx';

import * as S from './elements';

interface Props {
  location?: LocationFilterDTO;
  onNavigateToLocationList?: () => void;
}

export const LocationHeader: FC<Props> = ({
  location,
  onNavigateToLocationList,
}) => {
  return (
    <S.Container>
      <Breadcrumbs>
        <Breadcrumbs.Item
          icon={<ListIcon />}
          label="Locations"
          onClick={onNavigateToLocationList}
        />
        <Breadcrumbs.Item icon={<LocationIcon />} label={location?.name} />
      </Breadcrumbs>
    </S.Container>
  );
};
